export default __webpack_public_path__ + "static/favicon-b98b26c8c6e8e62b9e757f31d5bd0ba7.ico";